import React from "react";
import { useEffect } from "react";
//import {MdOutlineModeEdit} from "react-icons/md"; 
import { IoCopyOutline } from "react-icons/io5";
import { GiSandsOfTime } from "react-icons/gi";
import COLORS from "../styles/COLORS";

export default (props) => {
  const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
  return (
    <div>
      {/*<label htmlFor='updId'> <MdOutlineModeEdit className="icn"  style={{marginLeft: '-10px' }} data-toggle="tooltip" data-placement="top" title="Update" data-action="update"  /> </label>*/}
      {/* <label htmlFor='cpyId'> <IoCopyOutline className="icn" style={{marginLeft: '-10px' }} data-toggle="tooltip" data-placement="top" title="Copy" data-action="copy"  /></label> */}
      {props.data.in_progress ? <GiSandsOfTime className="icn" /> : <IoCopyOutline color={ props.isDisabled ? COLORS.disabledGrey : COLORS.green }  className="icn" />}
    </div>
  )
}